(()=>{
  'use strict';

  const clean = value => String(value || '').replace(/\D/g, '').slice(0, 6);
  const isValidIndianPincode = value => /^[1-9]\d{5}$/.test(value);

  const setResult = (form, status, html) => {
    const box = form.closest('.sd-delivery');
    const out = box && box.querySelector('[data-pincode-result]');
    if (!out) return;
    out.dataset.status = status;
    out.setAttribute('aria-live', 'polite');
    out.innerHTML = html;
  };

  const injectStyles = () => {
    if (document.getElementById('sdpc-pincode-styles')) return;
    const style = document.createElement('style');
    style.id = 'sdpc-pincode-styles';
    style.textContent = `
      .sd-delivery__result[data-status="success"]{color:#61d681}
      .sd-delivery__result[data-status="error"]{color:#ff6673}
      .sd-delivery__result strong{color:inherit}
    `;
    document.head.appendChild(style);
  };

  injectStyles();

  document.addEventListener('input', event => {
    const input = event.target.closest('[data-pincode-form] input');
    if (!input) return;
    const next = clean(input.value);
    if (input.value !== next) input.value = next;
    const form = input.closest('[data-pincode-form]');
    if (form && next.length < 6) {
      const box = form.closest('.sd-delivery');
      const out = box && box.querySelector('[data-pincode-result]');
      if (out) {
        out.dataset.status = '';
        out.textContent = 'Usually delivered in 3–7 business days.';
      }
    }
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-pincode-form]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const input = form.querySelector('input');
    const pincode = clean(input && input.value);
    if (input) input.value = pincode;

    if (!isValidIndianPincode(pincode)) {
      setResult(
        form,
        'error',
        '<strong>Enter a valid 6-digit Indian pincode.</strong>'
      );
      return;
    }

    setResult(
      form,
      'success',
      `<strong>Yes, delivery is available to ${pincode}.</strong><br>Usually delivered in 3–7 business days. COD availability is confirmed at checkout.`
    );
  }, true);
})();
